import * as React from 'react';

import ERPHelpLink from '~/Help/ERPHelpLink';

import { formatNumericHumanDate } from '~/DateTime';
import ERPAddDataButton from './ERPAddDataButton';

const ERPDetailSummary = ({
	erpDate,
	virtualProductPackName,
	onDataAddRequest,
}: {
	erpDate: Date;
	virtualProductPackName: string;
	onDataAddRequest: () => void;
}) => {
	return (
		<div className='px-10 bg-cBlue-50 border-b border-gray-200'>
			<div className='pt-2 w-full max-w-7xl mx-auto'>
				<ul className='flex justify-start cogvio-breadcrumb'>
					<li className='relative mr-6'>
						<span className='text-label font-semibold'>IRP</span>
					</li>
					<li>
						<span className='text-label text-gray-500'>
							{formatNumericHumanDate(erpDate)} - {virtualProductPackName}
						</span>
					</li>
				</ul>
			</div>
			<div className='py-6 w-full max-w-7xl mx-auto'>
				<h1 className='font-display text-h3 font-semibold text-gray-800 tracking-wider'>
					{formatNumericHumanDate(erpDate)} - {virtualProductPackName}
				</h1>

				<div className='pt-5 flex items-stretch items-start'>
					<div className='pr-8 max-w-sm'>
						<h2 className='mb-0.5 font-display text-base font-medium text-cPurple-600 tracking-wider'>
							Price input, volume &amp; growth
						</h2>
						<p className='mb-2 font-display text-label leading-normal text-gray-500 tracking-wide'>
							View and correct the input prices. Add or update the volume & growth data to see revenues.
						</p>

						<ERPAddDataButton onDataAddRequest={onDataAddRequest} />
					</div>
					<div className='px-8 border-l border-gray-300 max-w-md'>
						<h2 className='mb-0.5 font-display text-base font-medium text-cPurple-600 tracking-wider'>Help</h2>
						<p className='mb-2 font-display text-label leading-normal text-gray-500 tracking-wide'>
							View the list of countries and rules, that are implemented within this version of the external reference
							pricing model.
						</p>
						<ERPHelpLink className='mr-2 btn-white-second' />
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ERPDetailSummary);
